var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36571 11.6025C2.1083 12.115 1.44775 12.872 1.44775 13.969C1.44775 15.6059 4.82905 16.9328 9.0001 16.9328C13.1711 16.9328 16.5524 15.6059 16.5524 13.969C16.5524 12.872 15.7202 12.3125 13.4628 11.8001",
    stroke: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99997 3.97415C8.4844 3.97415 8.06644 4.39211 8.06644 4.90769C8.06644 5.42327 8.4844 5.84122 8.99997 5.84122C9.51555 5.84122 9.93351 5.42327 9.93351 4.90769C9.93351 4.39211 9.51555 3.97415 8.99997 3.97415ZM7.16748 4.90769C7.16748 3.89563 7.98792 3.0752 8.99997 3.0752C10.012 3.0752 10.8325 3.89563 10.8325 4.90769C10.8325 5.91975 10.012 6.74018 8.99997 6.74018C7.98792 6.74018 7.16748 5.91975 7.16748 4.90769Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00022 0.966098C11.1772 0.966098 12.9418 2.73081 12.9418 4.90769C12.9418 5.6727 12.686 6.55043 12.2455 7.47683C11.809 8.39501 11.2182 9.30512 10.6127 10.1194C10.3169 10.5171 10.0207 10.888 9.74188 11.2214L10.3282 11.9208C11.8052 10.1757 13.8408 7.33112 13.8408 4.90769C13.8408 2.23435 11.6737 0.0671387 9.00022 0.0671387C6.32671 0.0671387 4.15967 2.23435 4.15967 4.90769C4.15967 7.85529 6.96329 11.4259 8.22484 12.8834C8.59107 13.3065 8.82734 13.5515 8.82734 13.5515C8.82734 13.5515 9.0722 13.3151 9.45369 12.9057C8.78208 12.1525 8.86909 12.2546 8.78208 12.1525C8.35832 11.6555 7.79457 10.9559 7.23262 10.1441C6.07369 8.47014 5.05863 6.50979 5.05863 4.90769C5.05863 2.73081 6.82321 0.966098 9.00022 0.966098Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentPosition);
export default __webpack_public_path__ + "static/media/current-position.9d79ba3d49167e396b5f1c643b1725ae.svg";
export { ForwardRef as ReactComponent };